import * as types from './types'
import { ExternalSystemListResponse } from '@cbgms/api/modules/shops/external-systems'
import { AnyAction } from 'redux'

const defaultState: ExternalSystemListResponse[] = []

export const shopExternalSystems = (state = defaultState, action: AnyAction) => {
  switch (action.type) {
    case types.GET_EXTERNAL_SYSTEMS_SUCCESS:
    case types.POST_EXTERNAL_SYSTEM_SUCCESS:
    case types.PUT_EXTERNAL_SYSTEM_SUCCESS:
    case types.DELETE_EXTERNAL_SYSTEM_SUCCESS:
      return action.payload.data.Data as ExternalSystemListResponse[]
    default:
      return state
  }
}
